import React, { useState } from "react";
import Select from "react-select";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import "./CustomSelect.css";


const CustomSelect = ({
  options = [],
  value = "",
  onChange,
  label = "",
  name = "",
  placeholder = "Select",
  required = false,
  error = "",
  className = "",
  id,
  isDisabled = false,
  isSearchable = true,
  isClearable = false,
  ...rest
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedValue = options.find((opt) => opt.value === value) || null;

  const handleSelectChange = (selectedOption) => {
    // ------------ Error hide + value update ------------
    onChange({
      target: {
        name: name,
        value: selectedOption ? selectedOption.value : "",
      },
    });
  };

  // ------------ Label click → open dropdown ------------
  const handleLabelClick = () => {
    const selectInput = document.getElementById(id || name);
    if (selectInput) {
      selectInput.focus();
      selectInput.click();
    }
  };

  // ------------ Custom Styles ------------
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "42px",
      borderColor: error
        ? "#dc3545"
        : state.isFocused ? "#007bff" : "#ccc",
      boxShadow: "none",
      fontSize: "1rem",
      borderRadius: "6px",
      paddingRight: "36px",
      "&:hover": {
        borderColor: error ? "#dc3545" : "#007bff",
      },
    }),

    dropdownIndicator: () => ({ display: "none" }),
    indicatorSeparator: () => ({ display: "none" }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 12px",
    }),

    // 🔥 FIX — REQUIRED FOR OPTIONS TO SHOW
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };


  return (
    <div className={`custom-select-group ${className}`}>
      {label && (
        <label
          htmlFor={id || name}
          className="custom-select-label"
          onClick={handleLabelClick}
        >
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="select-wrapper">
        <Select
          id={id || name}
          name={name}
          value={selectedValue}
          onMenuOpen={() => setIsOpen(true)}
          onMenuClose={() => setIsOpen(false)}
          onChange={handleSelectChange}
          options={options}
          placeholder={placeholder}
          isDisabled={isDisabled}
          isSearchable={isSearchable}
          isClearable={isClearable}
          styles={customStyles}

          menuPortalTarget={document.body}
          menuShouldScrollIntoView={false}
          menuPosition="fixed"
        />


        {/* Arrow Icon */}
        <div className={`arrow-icon ${isOpen ? "open" : ""}`}>
          {isOpen ? <IoChevronUp /> : <IoChevronDown />}
        </div>
      </div>

      {error && <div className="custom-select-error">{error}</div>}
    </div>
  );
};

export default CustomSelect;
